"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OurStoryLinks = void 0;
let OurStoryLinks = exports.OurStoryLinks = /*#__PURE__*/function (OurStoryLinks) {
  OurStoryLinks["ProductPhilosophy"] = "/product-philosophy";
  OurStoryLinks["SupportCenter"] = "/support-center";
  OurStoryLinks["Sustainability"] = "/sustainability";
  OurStoryLinks["WhoWeAre"] = "/about";
  return OurStoryLinks;
}({});
